import React from "react";
import { projects } from "../data";

export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-10">
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            A Selection of Applications I've Developed
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-base sm:text-lg md:text-xl">
            Explore a selection of applications I’ve developed as a software
            engineer. These projects reflect my deep expertise in full-stack
            development, with a strong focus on delivering high-quality,
            scalable solutions.
          </p>
        </div>

        {/* 🔥 Use Grid for Responsive Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="block transform transition duration-300 hover:scale-105"
            >
              <div className="relative rounded-lg overflow-hidden shadow-lg border border-gray-800">
                {/* ✅ Responsive Image */}
                <img
                  alt="gallery"
                  className="w-full h-auto object-cover"
                  src={project.image}
                />
                {/* 🔥 Hover Effect for Text */}
                <div className="absolute inset-0 bg-gray-900 bg-opacity-80 opacity-0 hover:opacity-100 flex flex-col justify-center items-center text-center transition duration-300">
                  <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-white mb-3">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed px-4">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

/* import { CodeIcon } from "@heroicons/react/solid";
import React from "react";
import { projects } from "../data";
export default function Projects() {
  return (
    <section id="projects" className="text-gray-400 bg-gray-900 body-font">
      <div className="container px-5 py-10 mx-auto text-center lg:px-40">
        <div className="flex flex-col w-full mb-20">
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            A Selection of Applications I've Developed
          </h1>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-left">
            Explore a selection of applications I’ve developed as a software
            engineer. These projects reflect my deep expertise in full-stack
            development, with a strong focus on delivering high-quality,
            scalable solutions. I take pride in completing each project within
            the agreed timeline, while maintaining the highest standards of
            usability, performance, and functionality. My passion for
            problem-solving and continuous learning drives every application I
            build."
          </p>
        </div>
        <div className="flex flex-wrap -m-4">
          {projects.map((project) => (
            <a
              href={project.link}
              key={project.image}
              className="sm:w-1/2 w-100 p-4"
            >
              <div className="flex relative">
                <img
                  alt="gallery"
                  className="absolute inset-0 w-full h-full object-cover object-center"
                  src={project.image}
                />
                <div className="px-8 py-10 relative z-10 w-full border-4 border-gray-800 bg-gray-900 opacity-0 hover:opacity-100">
                  <h2 className="tracking-widest text-sm title-font font-medium text-green-400 mb-1">
                    {project.subtitle}
                  </h2>
                  <h1 className="title-font text-lg font-medium text-white mb-3">
                    {project.title}
                  </h1>
                  <p className="leading-relaxed">{project.description}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
} */



// WEBPACK FOOTER //
// ./src/components/Projects.js